import React from 'react';
import './ChatIcon.css';

function ChatIcon({ src, alt, user, name }) {
    const shouldShowLetter = !src && !user;

    return (
        <div className="user-icon">
            {shouldShowLetter ? (
                <div className="user-avatar-circle bg-blue-500 text-white flex items-center justify-center rounded-full w-8 h-8 text-lg">
                    {name ? name.charAt(0) : "N"}
                </div>
            ) : (
                <img src={src} alt={alt} className={user ? "user-icon-image" : "chat-icon-image"} />
            )}
        </div>
    );
}

export default ChatIcon;
